import * as actions from "../constants/addressConstants";
import axios from "axios";
import config from "utils/config";
import { AddressType } from "data/types";
import redirect from "utils/redirect";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import { RentripsURL } from "utils/request";

export const getAddress = () => async (dispatch: any, getState: any) => {
  try {
    dispatch({
      type: actions.USER_ADDRESS_REQUEST,
    });

    const token = getState().userInfo.userInfo.token || "";
    const { data } = await axios.get(`${RentripsURL}/api/address/`, config(token));

    dispatch({
      type: actions.USER_ADDRESS_REQUEST_SUCCESS,
      payload: data,
    });

    localStorage.setItem("addresses", JSON.stringify(data));
  } catch (error: any) {
    dispatch({
      type: actions.USER_ADDRESS_REQUEST_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    redirect(error, dispatch);
  }
};

export const addAddress =
  (address: AddressType) => async (dispatch: any, getState: any) => {
    const { userInfo } = getState().userInfo;
    const { token } = getState().userInfo.userInfo;

    try {
      const { data } = await axios.post(
        RentripsURL + "/api/address/",
        { address },
        config(token)
      );

      logging(token, {
        category: "address",
        action: "add",
        target: data._id || data.id,
      });

      const { addresses } = getState().addressList;
      addresses.push(data);

      dispatch({
        type: actions.USER_ADDRESS_ADD_SUCCESS,
        payload: addresses,
      });
      eventAnalytic({
        category: "User",
        action: "Add address",
        label: `${userInfo?.id || userInfo._id}`,
      });
    } catch (error: any) {
      eventAnalytic({
        category: "User",
        action: "Add address failed",
        label: `${userInfo?.id || userInfo._id}`,
      });
      dispatch({
        type: actions.USER_ADDRESS_ADD_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      redirect(error, dispatch);
    }
  };

export const updateAddress =
  (address: AddressType) => async (dispatch: any, getState: any) => {
    try {
      const { token } = getState().userInfo.userInfo;

      const { data } = await axios.patch(
        RentripsURL + `/api/address/${address._id}`,
        {
          address,
        },
        config(token)
      );

      logging(token, {
        category: "address",
        action: "update",
        target: address._id,
      });

      const { addresses } = getState().addressList;

      // Cari index si address
      const addressIndex = addresses.findIndex(
        (i: AddressType) => i._id === address._id
      );

      // ubah dia
      addresses[addressIndex] = data;

      dispatch({
        type: actions.USER_ADDRESS_UPDATE_SUCCESS,
        payload: addresses,
      });
      eventAnalytic({
        category: "User",
        action: "update address",
        label: address._id,
      });
    } catch (error: any) {
      eventAnalytic({
        category: "User",
        action: "update address failed",
        label: address._id,
      });
      dispatch({
        type: actions.USER_ADDRESS_UPDATE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      redirect(error, dispatch);
    }
  };

export const primaryAddress =
  (id: string) => async (dispatch: any, getState: any) => {
    try {
      const { token } = getState().userInfo.userInfo;

      const { data } = await axios.get(RentripsURL +`/api/address/${id}`, config(token));

      logging(token, {
        category: "address",
        action: "primary",
        target: id,
      });

      dispatch({
        type: actions.USER_ADDRESS_UPDATE_SUCCESS,
        payload: data,
      });
      eventAnalytic({
        category: "User",
        action: "primary address",
        label: id,
      });
    } catch (error: any) {
      eventAnalytic({
        category: "User",
        action: "primary address failed",
        label: id,
      });
      dispatch({
        type: actions.USER_ADDRESS_UPDATE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      redirect(error, dispatch);
    }
  };

export const deleteAddress =
  (id: string) => async (dispatch: any, getState: any) => {
    try {
      const { token } = getState().userInfo.userInfo;
      const { addresses } = getState().addressList;

      logging(token, {
        category: "address",
        action: "delete",
        target: id,
      });

      const { data } = await axios.delete(RentripsURL +`api/address/${id}`, config(token));

      const addressesCopy = [...addresses] || [];

      const newAddress = addressesCopy.filter(
        (address) => address._id !== data._id
      );

      dispatch({
        type: actions.USER_ADDRESS_DELETE_SUCCESS,
        payload: newAddress,
      });
      eventAnalytic({
        category: "User",
        action: "delete address",
        label: id,
      });
    } catch (error: any) {
      eventAnalytic({
        category: "User",
        action: "delete address failed",
        label: id,
      });
      dispatch({
        type: actions.USER_ADDRESS_DELETE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      redirect(error, dispatch);
    }
  };
